import { returnFlowPaths } from 'routes/ReturnFlow/paths'
import { paths as storagePaths } from 'routes/Storage/paths'
import { paths as storageUnitPaths } from 'routes/StorageUnitFlow/paths'
import { pathTo } from 'utils'

const Home = '/'
const Login = '/login'
const LoginCallback = pathTo(Login, 'callback')
const Register = '/register'
const Space = pathTo('/space')
const MySubscription = pathTo(Space, 'my-subscription')
const MyItemsView = pathTo(Space, 'my-items')
const NoImageItemView = pathTo(Space, 'no-image-view')
const ItemDetails = (id: string) => pathTo(Space, 'item', id)
const CreateItem = (id: string) => pathTo(Space, 'item', 'create', id)

const Settings = pathTo(Space, 'settings')
const EditAddress = pathTo(Settings, 'address')
const ResetPassword = pathTo('/password-reset')
const ChangePassword = pathTo(Settings, 'password')
const Invoices = pathTo(Settings, 'invoices')
const Orders = pathTo(Settings, 'orders')
const Redirect = pathTo('/redirect')
const PackagingOrders = pathTo(Settings, 'packaging-orders')
const TransportOrders = pathTo(Settings, 'transport-orders')
const SelectAccounts = pathTo(Settings, '/select-account')
const EditUserDetails = pathTo(Settings, 'user-details')

const EditOrderDetails = (id: string) => pathTo(Space, 'edit-order', id)
const EditOrderAddress = (id: string) => pathTo(Space, 'edit-order', id, 'address')
const EditOrderCarrying = (id: string) => pathTo(Space, 'edit-order', id, 'carrying')
const EditOrderTime = (id: string) => pathTo(Space, 'edit-order', id, 'time')
const EditOrderAddPickupItems = (id: string) => pathTo(Space, 'edit-order', id, 'pickup-items')
const EditOrderAddDeliveryItems = (id: string) => pathTo(Space, 'edit-order', id, 'delivery-items')
const EditOrderPacking = (id: string) => pathTo(Space, 'edit-order', id, 'packing')

const Billing = pathTo(Settings, 'billing')
const Shop = pathTo('/packaging')
const ShopSummary = pathTo(Shop, 'summary')
const ShopCheckout = pathTo(Shop, 'checkout')
const ShopCheckoutConfirmation = pathTo(Shop, ShopCheckout, 'checkoutconfirm')
const ShopRequireRegistration = pathTo(Shop, 'register')
const PriceIncrease = pathTo(Settings, 'price-increase')

const SharingInfo = (id: string) => pathTo('/sharing', id)
const Storage = pathTo('storage')
const StorageSelectItems = pathTo(Storage, storagePaths.selectItems)
const StorageSelectExistingItems = pathTo(Storage, storagePaths.existingItems)
const StorageSchedule = pathTo(Storage, storagePaths.schedule)
const StorageCarrying = pathTo(Storage, storagePaths.carrying)
const StorageSummary = pathTo(Storage, storagePaths.summary)
const StorageAddress = pathTo(Storage, storagePaths.address)
const SelectFlow = pathTo('/select-flow')
const SelectStorage = pathTo(SelectFlow, '/storage')
const CollectPostCode = pathTo('/post-code')
const CollectEmail = pathTo('/finish-logging-in')
const CollectUserInfo = pathTo('finish-signing-up')
const ReturnFlow = '/return-flow'
const MyTransfers = pathTo('/my-transfers')

const ReturnFlowSelectItems = pathTo(ReturnFlow, returnFlowPaths.selectItems)
const ReturnFlowSchedule = pathTo(ReturnFlow, returnFlowPaths.schedule)
const ReturnFlowCarrying = pathTo(ReturnFlow, returnFlowPaths.carrying)
const ReturnFlowSummary = pathTo(ReturnFlow, returnFlowPaths.summary)
const ReturnFlowaddress = pathTo(ReturnFlow, returnFlowPaths.address)

const StorageUnitFlow = pathTo('/storage-unit-flow')
const StorageUnitFlowSchedule = pathTo(StorageUnitFlow, storageUnitPaths.schedule)
const StorageUnitFlowWarehouse = pathTo(StorageUnitFlow, storageUnitPaths.selectWarehouse)

export const Routes = {
  Home,
  Login,
  Register,
  Space,
  MyItemsView,
  NoImageItemView,
  CreateItem,
  ItemDetails,
  Settings,
  EditAddress,
  ResetPassword,
  ChangePassword,
  Billing,
  Invoices,
  PackagingOrders,
  TransportOrders,
  Orders,
  EditOrderDetails,
  EditOrderAddress,
  EditOrderTime,
  EditOrderCarrying,
  EditOrderAddPickupItems,
  EditOrderAddDeliveryItems,
  EditOrderPacking,
  LoginCallback,
  PriceIncrease,
  SharingInfo,
  Shop,
  ShopCheckout,
  ShopSummary,
  ShopCheckoutConfirmation,
  MySubscription,
  Redirect,
  Storage,
  StorageSelectItems,
  StorageSelectExistingItems,
  StorageSchedule,
  StorageCarrying,
  StorageSummary,
  StorageAddress,
  SelectFlow,
  CollectPostCode,
  ReturnFlow,
  ReturnFlowSelectItems,
  ReturnFlowSchedule,
  ReturnFlowCarrying,
  ReturnFlowSummary,
  ReturnFlowaddress,
  SelectStorage,
  ShopRequireRegistration,
  CollectEmail,
  SelectAccounts,
  MyTransfers,
  StorageUnitFlow,
  StorageUnitFlowSchedule,
  StorageUnitFlowWarehouse,
  CollectUserInfo,
  EditUserDetails,
}
